<script setup lang="ts">
import type { Product } from '~~/graphql/operations'

const props = defineProps<{
  product: {
    value: number
    label: string
  }
}>()
const parsedProduct = computed(
  () => JSON.parse(props.product?.label || '') as Product,
)
const deliveryDays = parsedProduct.value?.manufacturer?.deliveryDays
</script>
<template>
  <div v-if="product" class="flex flex-row min-h-10">
    <div class="w-12 h-auto min-w-12">
      <img class="rounded-sm" :src="parsedProduct.defaultImage?.image?.fileUrl" />
    </div>
    <div class="pl-8 w-auto">
      <p class="font-bold">
        <span class="w-11/12">{{ parsedProduct?.defaultText.name }}</span>
      </p>
      <div class="flex flex-col justify-between md:flex-row">
        <div class="pl-4 sm:pl-0 text-xs">
          <p>Product Number: {{ parsedProduct.productNumber }}</p>
          <p>
            Supp. Product Num: {{ parsedProduct.supplierProductNumber }}
          </p>
          <div
            class="flex content-center"
            :class="{ 'text-red-500': !deliveryDays }"
          >
            <div class="w-5 i-icon-park-outline:truck inline-block text-sm" />
            <span class="ml-2 font-medium">{{ deliveryDays || '???' }}</span>
          </div>
        </div>
        <div class="pl-4 text-xs min-w-32">
          <p>Available: {{ parsedProduct.defaultStock?.available }}</p>
          <p>Sellable Stock: {{ parsedProduct.defaultStock?.sellableStock }}</p>
          <p>
            Available Stock: {{ parsedProduct.defaultStock?.availableStock }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
